import React, { Component } from "react";
import {
  Button,
  Container,
  Row, Form,
  Col,
  Offcanvas,
} from "react-bootstrap";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import configData from '../config.json';

import LoadingOverlay from "./LoadingOverlay";
export default class Apiendpoint extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      loadingMessage: "Processing your request...",
      show: false,
      data: [],
      sId: sessionStorage.getItem("sessionId"),
      uId: sessionStorage.getItem("uId"),
      errors: {},
      filteredData: null,
      tableClms: [
        {
          name: "S.NO",
          selector: (row, i) => row.apiendpoint_Id,
          sortable: true,
          cell: (row) => <span>{row.apiendpoint_Id}</span>,
        },
        { name: "Name", selector: (row, i) => row.name, sortable: true, cell: (row) => <span>{row.name}</span>, }, { name: "URL", selector: (row, i) => row.url, sortable: true, cell: (row) => <span>{row.url}</span>, }, { name: "Method", selector: (row, i) => row.method, sortable: true, cell: (row) => <span>{row.method}</span>, }, { name: "Header JSON", selector: (row, i) => row.headersJSON, sortable: true, cell: (row) => <span>{row.headersJSON}</span>, }, { name: "Authentication Type", selector: (row, i) => row.authenticationType, sortable: true, cell: (row) => <span>{row.authenticationType}</span>, }, { name: "Authentication Config JSON", selector: (row, i) => row.authenticationconfigJSON, sortable: true, cell: (row) => <span>{row.authenticationconfigJSON}</span>, }, { name: "Retry Config JSON", selector: (row, i) => row.retryconfigJSON, sortable: true, cell: (row) => <span>{row.retryconfigJSON}</span>, }, { name: "Timeout Seconds", selector: (row, i) => row.timeoutseconds, sortable: true, cell: (row) => <span>{row.timeoutseconds}</span>, }, { name: "Is Active", selector: (row, i) => row.isActive, sortable: true, cell: (row) => <span>{row.isActive}</span>, }, { name: "Dummy One", selector: (row, i) => row.dummyOne, sortable: true, cell: (row) => <span>{row.dummyOne}</span>, }, { name: "Dummy Two", selector: (row, i) => row.dummyTwo, sortable: true, cell: (row) => <span>{row.dummyTwo}</span>, }, { name: "Dummy Three", selector: (row, i) => row.dummyThree, sortable: true, cell: (row) => <span>{row.dummyThree}</span>, }, { name: "Dummy Four", selector: (row, i) => row.dummyFour, sortable: true, cell: (row) => <span>{row.dummyFour}</span>, }, { name: "Dummy Five", selector: (row, i) => row.dummyFive, sortable: true, cell: (row) => <span>{row.dummyFive}</span>, },
        //***tableClms
        {
          name: "Actions",
          sortable: false,
          cell: (row) => (
            <div>
              {/* edit button and delete button */}
              <Button
                style={{ marginRight: "10px" }}
                variant="primary"
                onClick={() => this.ApiendpointeditHandler(row)}
                className="bi bi-pen"
              >
              </Button>
              <Button
                variant="danger"
                onClick={() => this.handleDelete(row)}
                className="bi bi-trash danger"
              >
              </Button>
            </div>
          ),
        },
      ],
      currentPage: 1,
      itemsPerPage: 10,
      isEditing: false,
      apiendpoint_Id: "",
      name: '', url: '', method: '', headersJSON: '', authenticationType: '', authenticationconfigJSON: '', retryconfigJSON: '', timeoutseconds: '', isActive: '', dummyOne: '', dummyTwo: '', dummyThree: '', dummyFour: '', dummyFive: '',
      //***state
    };
  }
  // offcanvas Open
  handleOffcanvasShow = () => {
    this.setState({ show: true, name: '', url: '', method: '', headersJSON: '', authenticationType: '', authenticationconfigJSON: '', retryconfigJSON: '', timeoutseconds: '', isActive: '', dummyOne: '', dummyTwo: '', dummyThree: '', dummyFour: '', dummyFive: '', });
  };
  // Offcanvas close button
  handleOffcanvasClose = () => {
    this.setState({ show: false, isEditing: false, name: '', url: '', method: '', headersJSON: '', authenticationType: '', authenticationconfigJSON: '', retryconfigJSON: '', timeoutseconds: '', isActive: '', dummyOne: '', dummyTwo: '', dummyThree: '', dummyFour: '', dummyFive: '', });
  };
  showToast = (msg, type) => {
    switch (type) {
      case "success":
        toast.success(msg);
        break;
      case "error":
        toast.error(msg);
        break;
      case "warning":
        toast.warn(msg); // 'warn' is used instead of 'warning'
        break;
      default:
        toast.info(msg);
    }
  };
  ApiendpointeditHandler = (row) => {
    // e.preventDefault();
    this.setState({
      isEditing: true, apiendpoint_Id: row.apiendpoint_Id, name: row.name, url: row.url, method: row.method, headersJSON: row.headersJSON, authenticationType: row.authenticationType, authenticationconfigJSON: row.authenticationconfigJSON, retryconfigJSON: row.retryconfigJSON, timeoutseconds: row.timeoutseconds, isActive: row.isActive, dummyOne: row.dummyOne, dummyTwo: row.dummyTwo, dummyThree: row.dummyThree, dummyFour: row.dummyFour, dummyFive: row.dummyFive, //***editstate
    });
  }

  ApiendpointfetchHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    fetch(configData.api_url + 'C_Apiendpoint/list', {  // Enter your IP address here

      method: 'POST',
      //headers :{ 'Content-Type' : 'application/json'},
      mode: 'cors',
      body: formData// body data type must match "Content-Type" header
    }).then(response => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ data: data.list });
        }
      });
  }
  ApiendpointsubmitHandler = (e) => {
    e.preventDefault();
    //   setButtons(contacts);
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append('name', this.state.name);
    formData.append('url', this.state.url);
    formData.append('method', this.state.method);
    formData.append('headersJSON', this.state.headersJSON);
    formData.append('authenticationType', this.state.authenticationType);
    formData.append('authenticationconfigJSON', this.state.authenticationconfigJSON);
    formData.append('retryconfigJSON', this.state.retryconfigJSON);
    formData.append('timeoutseconds', this.state.timeoutseconds);
    formData.append('isActive', this.state.isActive);
    formData.append('dummyOne', this.state.dummyOne);
    formData.append('dummyTwo', this.state.dummyTwo);
    formData.append('dummyThree', this.state.dummyThree);
    formData.append('dummyFour', this.state.dummyFour);
    formData.append('dummyFive', this.state.dummyFive);

    //***tableData*
    this.setState({ loading: true, loadingMessage: "Saving..." });
    fetch(configData.api_url + 'C_Apiendpoint/add', {  // Enter your IP address here

      method: 'POST',
      //headers :{ 'Content-Type' : 'application/json'},
      mode: 'cors',
      body: formData// body data type must match "Content-Type" header
    }).then(response => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.ApiendpointfetchHandler();
          this.handleOffcanvasClose();
          this.setState({ name: '', url: '', method: '', headersJSON: '', authenticationType: '', authenticationconfigJSON: '', retryconfigJSON: '', timeoutseconds: '', isActive: '', dummyOne: '', dummyTwo: '', dummyThree: '', dummyFour: '', dummyFive: '', });
        }
      
        this.setState({ loading: false });})
    .catch(() => { this.setState({ loading: false }); });
  }
  ApiendpointupdateHandler = (e) => {
    e.preventDefault();
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("apiendpoint_Id", this.state.apiendpoint_Id);
    formData.append('name', this.state.name);
    formData.append('url', this.state.url);
    formData.append('method', this.state.method);
    formData.append('headersJSON', this.state.headersJSON);
    formData.append('authenticationType', this.state.authenticationType);
    formData.append('authenticationconfigJSON', this.state.authenticationconfigJSON);
    formData.append('retryconfigJSON', this.state.retryconfigJSON);
    formData.append('timeoutseconds', this.state.timeoutseconds);
    formData.append('isActive', this.state.isActive);
    formData.append('dummyOne', this.state.dummyOne);
    formData.append('dummyTwo', this.state.dummyTwo);
    formData.append('dummyThree', this.state.dummyThree);
    formData.append('dummyFour', this.state.dummyFour);
    formData.append('dummyFive', this.state.dummyFive);

    //***tableData1
    this.setState({ loading: true, loadingMessage: "Updating..." });
    fetch(configData.api_url + 'C_Apiendpoint/update', {
      method: 'POST',
      mode: 'cors',
      body: formData
    }).then(response => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.ApiendpointfetchHandler();
          this.handleOffcanvasClose();
        }
      
        this.setState({ loading: false });})
    .catch(() => { this.setState({ loading: false }); });
  }

  componentDidMount() {
    this.ApiendpointfetchHandler();

    //***componentDidMount
  }
  handlenameChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ name: fieldValue });
  }; handleurlChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ url: fieldValue });
  }; handlemethodChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ method: fieldValue });
  }; handleheadersJSONChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ headersJSON: fieldValue });
  }; handleauthenticationTypeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ authenticationType: fieldValue });
  }; handleauthenticationconfigJSONChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ authenticationconfigJSON: fieldValue });
  }; handleretryconfigJSONChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ retryconfigJSON: fieldValue });
  }; handletimeoutsecondsChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ timeoutseconds: fieldValue });
  }; handleisActiveChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ isActive: fieldValue });
  }; handledummyOneChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ dummyOne: fieldValue });
  }; handledummyTwoChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ dummyTwo: fieldValue });
  }; handledummyThreeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ dummyThree: fieldValue });
  }; handledummyFourChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ dummyFour: fieldValue });
  }; handledummyFiveChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ dummyFive: fieldValue });
  };
  //***inputFunctions
  handleRowSelect = (row) => {
    this.setState({
      selectedRow: row.index,
    });
  };
  handleRowUpdate = (newData, oldData) => {
    const data = [...this.state.data];
    const index = oldData.index;
    data[index] = newData;
    this.setState({ data });
  };

  handleEdit = (row) => {
    console.log(`Editing row with ID ${row.id}`);
    // implement your edit logic here
  };
  handleDelete = (row, index) => {
    var formData = new FormData();
    formData.append('apiendpoint_Id', row.apiendpoint_Id);
    this.setState({ loading: true, loadingMessage: "Deleting..." });
    fetch(configData.api_url + 'C_Apiendpoint/delete', {
      method: 'POST',
      mode: 'cors',
      body: formData
    }).then(response => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.ApiendpointfetchHandler();
        }
      
        this.setState({ loading: false });})
    .catch(() => { this.setState({ loading: false }); });
  };
  handlePageChange = (page) => {
    this.setState({ currentPage: page });
  };

  handlePerRowsChange = (newPerPage, page) => {
    this.setState({ itemsPerPage: newPerPage, currentPage: page });
  };

  handleFilter = (e) => {
    const searchValue = e.target.value.toLowerCase();
    const filteredData = this.state.data.filter((row) => {
      return Object.values(row).join(" ").toLowerCase().includes(searchValue);
    });
    this.setState({ filteredData });
  };

  render() {
    const paginatedData = this.state.filteredData
      ? this.state.filteredData.slice(
        (this.state.currentPage - 1) * this.state.itemsPerPage,
        this.state.currentPage * this.state.itemsPerPage
      )
      : this.state.data.slice(
        (this.state.currentPage - 1) * this.state.itemsPerPage,
        this.state.currentPage * this.state.itemsPerPage
      );

    return (
      <div className="page-title">
        <LoadingOverlay show={this.state.loading} message={this.state.loadingMessage} />
        <div className="row">
          <div className="col-md-12 col-sm-12 col-xs-12">
            <div className="x_panel">
              <div className="x_content">
                <div
                  id="datatable_wrapper"
                  className="dataTables_wrapper form-inline
                dt-bootstrap no-footer"
                >
                  <Row className="row">
                    <div>
                      <h3 className="logoskybluecolor" style={{ textAlign: "start" }}>Api End Point</h3>
                    </div>
                    <Col
                      className="d-flex justify-content-end"
                      style={{ marginRight: "5px", marginTop: "20px" }}
                    >

                      <Offcanvas
                        show={this.state.show}
                        onHide={this.handleOffcanvasClose}
                        {...this.props}
                        style={{ width: "500px" }}
                        placement="end"
                        backdrop="true"
                      >
                        <Offcanvas.Header closeButton>
                          <Offcanvas.Title>Add Apiendpoint</Offcanvas.Title>
                        </Offcanvas.Header>
                        <Offcanvas.Body>
                          <Container style={{ "overflowY": "auto", height: "auto" }}>
                            <Row className="divstyle">
                              <Row>
                                <Form>
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Name</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlenameChange} className="form-control" name="name" value={this.state.name} required="required" placeholder="Enter Name" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.name} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>URL</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handleurlChange} className="form-control" name="url" value={this.state.url} required="required" placeholder="Enter URL" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.url} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Method</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlemethodChange} className="form-control" name="method" value={this.state.method} required="required" placeholder="Enter Method" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.method} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Header JSON</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handleheadersJSONChange} className="form-control" name="headersJSON" value={this.state.headersJSON} required="required" placeholder="Enter Header JSON" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.headersJSON} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Authentication Type</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handleauthenticationTypeChange} className="form-control" name="authenticationType" value={this.state.authenticationType} required="required" placeholder="Enter Authentication Type" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.authenticationType} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Authentication Config JSON</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handleauthenticationconfigJSONChange} className="form-control" name="authenticationconfigJSON" value={this.state.authenticationconfigJSON} required="required" placeholder="Enter Authentication Config JSON" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.authenticationconfigJSON} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Retry Config JSON</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handleretryconfigJSONChange} className="form-control" name="retryconfigJSON" value={this.state.retryconfigJSON} required="required" placeholder="Enter Retry Config JSON" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.retryconfigJSON} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Timeout Seconds</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handletimeoutsecondsChange} className="form-control" name="timeoutseconds" value={this.state.timeoutseconds} required="required" placeholder="Enter Timeout Seconds" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.timeoutseconds} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Is Active</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handleisActiveChange} className="form-control" name="isActive" value={this.state.isActive} required="required" placeholder="Enter Is Active" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.isActive} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Dummy One</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handledummyOneChange} className="form-control" name="dummyOne" value={this.state.dummyOne} required="required" placeholder="Enter Dummy One" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dummyOne} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Dummy Two</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handledummyTwoChange} className="form-control" name="dummyTwo" value={this.state.dummyTwo} required="required" placeholder="Enter Dummy Two" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dummyTwo} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Dummy Three</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handledummyThreeChange} className="form-control" name="dummyThree" value={this.state.dummyThree} required="required" placeholder="Enter Dummy Three" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dummyThree} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Dummy Four</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handledummyFourChange} className="form-control" name="dummyFour" value={this.state.dummyFour} required="required" placeholder="Enter Dummy Four" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dummyFour} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Dummy Five</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handledummyFiveChange} className="form-control" name="dummyFive" value={this.state.dummyFive} required="required" placeholder="Enter Dummy Five" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dummyFive} </div>
                                  </Row><br />
                                  {/* tableContent */}
                                </Form>
                              </Row>
                            </Row>
                            <Row>
                              <Col
                                className="d-flex justify-content-end"
                                style={{ marginRight: "50px" }}
                              >
                                <Button
                                  className="button"
                                  variant="success"
                                  onClick={this.ApiendpointsubmitHandler}
                                  style={{
                                    marginTop: "20px",
                                  }}
                                >
                                  Save
                                </Button>
                              </Col>
                            </Row>
                          </Container>
                        </Offcanvas.Body>
                      </Offcanvas>
                      {this.state.isEditing && (
                        // Edit Offcanvas
                        <Offcanvas
                          show={this.state.isEditing}
                          // onHide={() => this.setState({ isEditing: false })}
                          onHide={this.handleOffcanvasClose}
                          {...this.props}
                          style={{ width: "500px" }}
                          placement="end"
                          backdrop="true"
                        >
                          <Offcanvas.Header closeButton>
                            <Offcanvas.Title>Edit Apiendpoint</Offcanvas.Title>
                          </Offcanvas.Header>
                          <Offcanvas.Body>
                            <Container style={{ "overflowY": "auto", height: "auto" }}>
                              <Row className="divstyle">
                                <Row>
                                  <Form>
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Name</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handlenameChange} className="form-control" name="name" value={this.state.name} required="required" placeholder="Enter Name" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.name} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>URL</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handleurlChange} className="form-control" name="url" value={this.state.url} required="required" placeholder="Enter URL" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.url} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Method</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handlemethodChange} className="form-control" name="method" value={this.state.method} required="required" placeholder="Enter Method" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.method} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Header JSON</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handleheadersJSONChange} className="form-control" name="headersJSON" value={this.state.headersJSON} required="required" placeholder="Enter Header JSON" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.headersJSON} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Authentication Type</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handleauthenticationTypeChange} className="form-control" name="authenticationType" value={this.state.authenticationType} required="required" placeholder="Enter Authentication Type" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.authenticationType} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Authentication Config JSON</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handleauthenticationconfigJSONChange} className="form-control" name="authenticationconfigJSON" value={this.state.authenticationconfigJSON} required="required" placeholder="Enter Authentication Config JSON" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.authenticationconfigJSON} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Retry Config JSON</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handleretryconfigJSONChange} className="form-control" name="retryconfigJSON" value={this.state.retryconfigJSON} required="required" placeholder="Enter Retry Config JSON" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.retryconfigJSON} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Timeout Seconds</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handletimeoutsecondsChange} className="form-control" name="timeoutseconds" value={this.state.timeoutseconds} required="required" placeholder="Enter Timeout Seconds" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.timeoutseconds} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Is Active</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handleisActiveChange} className="form-control" name="isActive" value={this.state.isActive} required="required" placeholder="Enter Is Active" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.isActive} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Dummy One</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handledummyOneChange} className="form-control" name="dummyOne" value={this.state.dummyOne} required="required" placeholder="Enter Dummy One" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dummyOne} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Dummy Two</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handledummyTwoChange} className="form-control" name="dummyTwo" value={this.state.dummyTwo} required="required" placeholder="Enter Dummy Two" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dummyTwo} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Dummy Three</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handledummyThreeChange} className="form-control" name="dummyThree" value={this.state.dummyThree} required="required" placeholder="Enter Dummy Three" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dummyThree} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Dummy Four</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handledummyFourChange} className="form-control" name="dummyFour" value={this.state.dummyFour} required="required" placeholder="Enter Dummy Four" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dummyFour} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Dummy Five</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handledummyFiveChange} className="form-control" name="dummyFive" value={this.state.dummyFive} required="required" placeholder="Enter Dummy Five" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dummyFive} </div>
                                    </Row><br />
                                    {/* tableContent */}
                                  </Form>
                                </Row>
                              </Row>
                              <Row>
                                <Col
                                  className="d-flex justify-content-end"
                                  style={{ marginRight: "50px" }}
                                >
                                  <Button
                                    className="button"
                                    variant="success"
                                    onClick={this.ApiendpointupdateHandler}
                                    style={{
                                      marginTop: "20px",
                                    }}
                                  >
                                    Update
                                  </Button>
                                </Col>
                              </Row>
                            </Container>
                          </Offcanvas.Body>
                        </Offcanvas>
                      )}
                      {/*offcanvas is over */}
                    </Col>
                  </Row>
                  <br />
                  <Row>
                    <div style={{ "marginRight": "5px" }}>
                      {/* searchbar,pagination,filter */}
                      <input
                        type="text"
                        style={{ float: "left", marginBottom: "10px" }}
                        onChange={this.handleFilter}
                        placeholder="Search..."
                      />
                      <Button
                        variant="primary"
                        className="bi bi-plus "
                        style={{ float: "right", marginBottom: "10px" }}
                        onClick={this.handleOffcanvasShow}
                      >
                        New
                      </Button>
                      <DataTable
                        data={paginatedData}
                        columns={this.state.tableClms}
                        pagination
                        paginationServer
                        paginationTotalRows={
                          this.state.filteredData
                            ? this.state.filteredData.length
                            : this.state.data.length
                        }
                        onChangeRowsPerPage={this.handlePerRowsChange}
                        onChangePage={this.handlePageChange}
                        paginationRowsPerPageOptions={[100, 200, 300, 400, 500, 600, 700, 800, 900, 1000]}
                        paginationPerPage={100}
                        keyField="id"
                        className="table table-striped table-bordered dataTable no-footer employeesTableIcons"
                      />
                    </div>
                  </Row>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    );
  }
}
